import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SavedFiltersComponent } from '../saved-filters/saved-filters.component';
import { SharedServicesService } from 'app/shared/sharedservices/shared-services.service';
import { ReportMainData } from 'app/ReportingModel/ReportFiltering';
import { DARK_PATH, LIGHT_PATH } from 'app/app-constants';
import { Report } from 'app/ReportingModel/ReportConstantsDto';
import { ReportingService } from '../reporting-service.service';


@Component({
  selector: 'app-reporting-parent',
  templateUrl: './reporting-parent.component.html',
  styleUrls: ['./reporting-parent.component.scss']
})
export class ReportingParentComponent implements OnInit {
  @ViewChild('scrollableDiv') scrollableDiv!: ElementRef;
  @ViewChild(SavedFiltersComponent) savedFiltersComponent!: SavedFiltersComponent;
  ReportMainData: ReportMainData;
  isLeftPanelOpened = false;
  selectedTabName: string = "";
  tabVal: string = '';
  loadBookedTimeByResourceReport = false;
  loadBookedTimeByEngagementReport = false;
  loadAvailabilityByForecastedHoursReport = false;
  loadAuditTrailReport = false;
  loadAdoptionReport = false;
  constructor(private router: Router, private sharedService: SharedServicesService, private reportService: ReportingService) {
    sessionStorage.setItem('isReporting', JSON.stringify(true));
  }

  ngOnInit(): void {
    
    this.sharedService.reportingHeaderMenus.subscribe((data) => {
      this.tabVal = '';
      this.sharedService.activeLink = data;
    })
    this.sharedService.getSavedReportDetailsEmitter()
      .subscribe(item => this.getSavedReportDetails(item));

      this.reportService.navigateToReportparent$.subscribe(() => {
        this.scrollableDiv.nativeElement.scrollIntoView();
    });
  }

  getSavedReportDetails(savedReportDetails: ReportMainData) {
    this.tabVal = 'NewReport';
    this.ReportMainData = new ReportMainData();
    this.ReportMainData = savedReportDetails;
  }

  onLeftPanelClickedFun(onLeftPanelClicked): void {
    this.isLeftPanelOpened = onLeftPanelClicked;
  }


  onScroll(el: HTMLElement){
    // this.scrollableDiv.nativeElement.scrollIntoView();
       // el.scrollIntoView();
  }

  

  ReportFun(data): void {
    //this.sharedService.activeLink = '';
    this.tabVal = 'NewReport';
    this.ReportMainData = new ReportMainData();
    this.ReportMainData.reportId = data.reportId;
    this.ReportMainData.reportName = data.reportName;
    this.ReportMainData.reportCode = data.reportCode;
    this.ReportMainData.savedReportId = 0;
    this.ReportMainData.savedReportName = '';
    this.ReportMainData.savedReportFilterParameters = '';
    //this.savedFiltersComponent.getSavedReports(this.reportId);
    this.loadReport();
  }

  tabClick(val) {
    this.tabVal = val;
    // this.ReportMainData.savedReportId = 0;
    // this.ReportMainData.savedReportName = '';
    // this.ReportMainData.savedReportFilterParameters = '';
    //this.sharedService.activeLink = ''
  }
  loadReport() {
    this.loadBookedTimeByResourceReport = false;
    this.loadBookedTimeByEngagementReport = false;
    this.loadAvailabilityByForecastedHoursReport = false;
    this.loadAuditTrailReport = false;
    this.loadAdoptionReport = false;
    switch (this.ReportMainData.reportCode) {
      case Report.ReportCode.BOOKEDTIMEBYRESOURCE_REPORTCODE:
        this.loadBookedTimeByResourceReport = true;
        break;
      case Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE:
        this.loadBookedTimeByEngagementReport = true;
        break;
      case Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE:
        this.loadAvailabilityByForecastedHoursReport = true;
        break;
      case Report.ReportCode.AUDITTRAIL_REPORTCODE:
        this.loadAuditTrailReport = true;
        break;
      case Report.ReportCode.ADOPTION_REPORTCODE:
        this.loadAdoptionReport = true;
        break;
    }
  }
}
